import { Router, NavigationEnd } from "@angular/router";
import { DOCUMENT } from "@angular/common";
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  HostListener,
  OnDestroy,
} from "@angular/core";
import { ROUTES } from "./sidebar-items";
import { Role } from "src/app/core/models/role";
import { AuthService } from "src/app/core/service/auth.service";
import { RouteInfo } from "./sidebar.metadata";
import { J } from "@angular/cdk/keycodes";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.sass"],
})
export class SidebarComponent implements OnInit, OnDestroy {
  public sidebarItems: any[];
  public ROUTES: RouteInfo[];
  level1Menu = "";
  level2Menu = "";
  level3Menu = "";
  public innerHeight: any;
  public bodyTag: any;
  listMaxHeight: string;
  listMaxWidth: string;
  userFullName: string;
  userImg: string;
  userType: string;
  headerHeight = 60;
  currentRoute: string;
  routerObj = null;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private authService: AuthService,
    private router: Router
  ) {
    const body = this.elementRef.nativeElement.closest("body");
    this.routerObj = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // logic for select active menu in dropdown
        const role = ["admin", "teacher", "student"];
        const currenturl = event.url.split("?")[0];
        const firstString = currenturl.split("/").slice(1)[0];

        if (role.indexOf(firstString) !== -1) {
          this.level1Menu = event.url.split("/")[2];
          this.level2Menu = event.url.split("/")[3];
        } else {
          this.level1Menu = event.url.split("/")[1];
          this.level2Menu = event.url.split("/")[2];
        }
        // close sidebar on mobile screen after menu select
        this.renderer.removeClass(this.document.body, "overlay-open");
      }
    });
  }
  @HostListener("window:resize", ["$event"])
  windowResizecall(event) {
    this.setMenuHeight();
    this.checkStatuForResize(false);
  }
  @HostListener("document:mousedown", ["$event"])
  onGlobalClick(event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.renderer.removeClass(this.document.body, "overlay-open");
    }
  }
  callLevel1Toggle(event: any, element: any) {
    if (element === this.level1Menu) {
      this.level1Menu = "0";
    } else {
      this.level1Menu = element;
    }
    const hasClass = event.target.classList.contains("toggled");
    if (hasClass) {
      this.renderer.removeClass(event.target, "toggled");
    } else {
      this.renderer.addClass(event.target, "toggled");
    }
  }
  callLevel2Toggle(event: any, element: any) {
    if (element === this.level2Menu) {
      this.level2Menu = "0";
    } else {
      this.level2Menu = element;
    }
  }
  callLevel3Toggle(event: any, element: any) {
    if (element === this.level3Menu) {
      this.level3Menu = "0";
    } else {
      this.level3Menu = element;
    }
  }

  role_id: any = "";
  menuDetails: any = [];
  menuArray: any = [];
  ngOnInit() {
    if (localStorage.getItem("currentUser")) {
      const userRole = localStorage.getItem("userRole");
      const currentUser = localStorage.getItem("currentUser");

      let parsedUser = JSON.parse(currentUser);

      this.userFullName = parsedUser.user_name;
      this.role_id = parsedUser.role_id;
      // this.userImg = this.authService.currentUserValue.img;

      // this.sidebarItems = ROUTES.filter((x) => x.role.indexOf(userRole) !== -1 || x.role.indexOf('All') !== -1);
      this.sidebarItems = [];
      this.menuDetails = localStorage.getItem("menuDetails");
      var parsedMenuObject = JSON.parse(atob(this.menuDetails));
      var dashboardRoute = "";

      if (this.role_id == 1 ||this.role_id == 2 || this.role_id == 3||this.role_id == 4||this.role_id == 5||this.role_id == 6|| this.role_id == 7||this.role_id == 8 || this.role_id == 9 ||this.role_id == 10 ||this.role_id == 11 || this.role_id == 12||this.role_id == 0 || this.role_id == 13) {
        dashboardRoute = "/mmportal/employee-dashboard";
      } else if (this.role_id == 4 || this.role_id == 5) {
      //  dashboardRoute = "/admin/employees/attendance";
      } else if (this.role_id == 6) {
  //      dashboardRoute = "/admin/dashboard/librarian-dashboard";
      } else if (this.role_id == 7) {
        dashboardRoute = "/mmportal/employee-dashboard";
       // dashboardRoute = "/admin/dashboard/support-staff-dashboard";
      } else if (this.role_id == 9) {
        //dashboardRoute = "/admin/dashboard/parent-dashboard";
      } else if (this.role_id == 8) {
        //dashboardRoute = "/admin/dashboard/student-dashboard";
      } else if (this.role_id == 10) {
        //dashboardRoute = "/admin/dashboard/hr-dashboard";
      } else if (this.role_id == 12) {
        //dashboardRoute = "/admin/dashboard/storekeeper-dashboard";
      } else if (this.role_id == 11) {
        //dashboardRoute = "/admin/dashboard/finance-admin-dashboard";
      } else if (this.role_id == 13) {
        //dashboardRoute = "/mmportal/executive-dashboard";
      } else if (this.role_id == 0) {
      //  dashboardRoute = "/admin/deployment/deployment";
      } else {
        dashboardRoute = "/authentication/signin";
      }

      if (
        this.role_id != 1 &&
        this.role_id != 2 &&
        this.role_id != 3 &&
        this.role_id != 5 &&
        this.role_id != 7 &&
        this.role_id != 6 &&
        this.role_id != 4 &&
        this.role_id != 6 &&
        this.role_id != 0
      ) {
        var defaultMenu = {
          id: 100,
          path: "",
          title: "Home",
          moduleName: "home",
          iconType: "material-icons-two-tone",
          icon: "home",
          class: "menu-toggle",
          groupTitle: false,
          badge: "",
          badgeClass: "",
          role: [this.userType],
          submenu: [
            {
              path: dashboardRoute,
              title: "Dashboard",
              moduleName: "home",
              iconType: "",
              icon: "",
              class: "ml-menu",
              groupTitle: true,
              badge: "",
              badgeClass: "",
              role: [""],
              submenu: [],
            },
          ],
        };
        this.sidebarItems.push(defaultMenu);
      } 
       else {
        // var defaultMenu2 = {
        //   id: 101,
        //   path: "",
        //   title: "Master Management",
        //   moduleName: "master",
        //   iconType: "material-icons-two-tone",
        //   icon: "settings",
        //   class: "menu-toggle",
        //   groupTitle: false,
        //   badge: "",
        //   badgeClass: "",
        //   role: [this.userType],
        //   submenu: [
        //     {
        //       path: "/admin/masters/all-masters",
        //       title: "Manage Master",
        //       moduleName: "masters",
        //       iconType: "",
        //       icon: "",
        //       class: "ml-menu",
        //       groupTitle: true,
        //       badge: "",
        //       badgeClass: "",
        //       role: [""],
        //       submenu: [],
        //     },
        //     {
        //       path: '/admin/role-menu-settings/role-menu-permissions',
        //       title: 'Role Menu Permissions',
        //       moduleName: 'role-menu-settings',
        //       iconType: '',
        //       icon: '',
        //       class: 'ml-menu',
        //       groupTitle: false,
        //       badge: '',
        //       badgeClass: '',
        //       role: [ '' ],
        //       submenu: []
        //     }
        //   ],
        // };
        // var defaultMenu = {
        //   id: 100,
        //   path: "",
        //   title: "Home",
        //   moduleName: "home",
        //   iconType: "material-icons-two-tone",
        //   icon: "home",
        //   class: "menu-toggle",
        //   groupTitle: false,
        //   badge: "",
        //   badgeClass: "",
        //   role: [this.userType],
        //   submenu: [
        //     {
        //       path: "/mmportal/employee-dashboard",
        //       title: "Employee Dashboard",
        //       moduleName: "home",
        //       iconType: "",
        //       icon: "",
        //       class: "ml-menu",
        //       groupTitle: true,
        //       badge: "",
        //       badgeClass: "",
        //       role: [""],
        //       submenu: [],
        //     },
        //     {
        //       path: "/admin/employees/attendance",
        //       title: "Individual Dashboard",
        //       moduleName: "home",
        //       iconType: "",
        //       icon: "",
        //       class: "ml-menu",
        //       groupTitle: true,
        //       badge: "",
        //       badgeClass: "",
        //       role: [""],
        //       submenu: [],
        //     },

        //     {
        //       path: "/mmportal/executive-dashboard",
        //       title: "Executive Dashboard",
        //       moduleName: "home",
        //       iconType: "",
        //       icon: "",
        //       class: "ml-menu",
        //       groupTitle: true,
        //       badge: "",
        //       badgeClass: "",
        //       role: [""],
        //       submenu: [],
        //     },
            
        //   ],
        // };
        if (this.role_id == 1 || this.role_id == 2 || this.role_id == 3 || this.role_id == 4||this.role_id == 5) {
         // this.sidebarItems.push(defaultMenu);
          //this.sidebarItems.push(defaultMenu2);
        }
        if( this.role_id == 0)
        {
          var reports = {
            id: 101,
            path: "",
            title: "Reports",
            moduleName: "report",
            iconType: "material-icons-two-tone",
            icon: "content_paste",
            class: "menu-toggle",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            role: [this.userType],
            submenu: [
              {
                path: "/admin/employees/attendance-monthly",
                title: "Attendance Details",
                moduleName: "attendance",
                iconType: "",
                icon: "",
                class: "ml-menu",
                groupTitle: true,
                badge: "",
                badgeClass: "",
                role: [""],
                submenu: [],
              },
              {
                path: "/admin/employees/attendance-summary",
                title: "Attendance Summary",
                moduleName: "summary",
                iconType: "",
                icon: "",
                class: "ml-menu",
                groupTitle: true,
                badge: "",
                badgeClass: "",
                role: [""],
                submenu: [],
              },
              {
                path: "/admin/employees/employee-attendance-report",
                title: "Employee Attendance Report",
                moduleName: "employee-attendance-report",
                iconType: "",
                icon: "",
                class: "ml-menu",
                groupTitle: true,
                badge: "",
                badgeClass: "",
                role: [""],
                submenu: [],
              },
            ],
          };

          // var defaultMenu = {
          //   id: 100,
          //   path: '',
          //   title: 'Home',
          //   moduleName: 'home',
          //   iconType: 'material-icons-two-tone',
          //   icon: 'home',
          //   class: 'menu-toggle',
          //   groupTitle: false,
          //   badge: '',
          //   badgeClass: '',
          //   role: [ this.userType ],
          //   submenu: [
          //     {
          //       path: dashboardRoute,
          //       title: 'Executive Dashboard',
          //       moduleName: 'home',
          //       iconType: '',
          //       icon: '',
          //       class: 'ml-menu',
          //       groupTitle: true,
          //       badge: '',
          //       badgeClass: '',
          //       role: [ '' ],
          //       submenu: []
          //     },
          //     {
          //       path: '/mmportal/school-dashboard',
          //       title: 'School Dashboard',
          //       moduleName: 'home',
          //       iconType: '',
          //       icon: '',
          //       class: 'ml-menu',
          //       groupTitle: true,
          //       badge: '',
          //       badgeClass: '',
          //       role: [ '' ],
          //       submenu: []
          //     },
          //     {
          //       path: '/mmportal/individual-dashboard',
          //       title: 'Individual Dashboard',
          //       moduleName: 'home',
          //       iconType: '',
          //       icon: '',
          //       class: 'ml-menu',
          //       groupTitle: true,
          //       badge: '',
          //       badgeClass: '',
          //       role: [ '' ],
          //       submenu: []
          //     }
          //   ]
          // };

          // this.sidebarItems.push(defaultMenu);
          // this.sidebarItems.push(defaultLeave)
          //this.sidebarItems.push(defaultMenu3)
          this.sidebarItems.push(reports)

          var defaultMenu = {
            id: 101,
            path: '',
            title: 'Canteen',
            moduleName: 'canteen',
            iconType: 'material-icons-two-tone',
            icon: 'local_dining',
            class: 'menu-toggle',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            role: [ this.userType ],
            submenu: [
              // {
              //   path: '/mmportal/canteen-dashboard',
              //   title: 'Canteen Dashboard',
              //   moduleName: 'canteen',
              //   iconType: '',
              //   icon: '',
              //   class: 'ml-menu',
              //   groupTitle: true,
              //   badge: '',
              //   badgeClass: '',
              //   role: [ '' ],
              //   submenu: []
              // },
              {
                path: '/mmportal/canteen-menu',
                title: 'Canteen Menu',
                moduleName: 'canteen',
                iconType: '',
                icon: '',
                class: 'ml-menu',
                groupTitle: true,
                badge: '',
                badgeClass: '',
                role: [ '' ],
                submenu: []
              },
              {
                path: '/mmportal/canteen-billing',
                title: 'Canteen Billing',
                moduleName: 'canteen',
                iconType: '',
                icon: '',
                class: 'ml-menu',
                groupTitle: true,
                badge: '',
                badgeClass: '',
                role: [ '' ],
                submenu: []
              }
            ]
          };
          this.sidebarItems.push(defaultMenu);
          //this.sidebarItems.push(defaultMenu2);
        }

        if (this.role_id == 1 || this.role_id == 2 || this.role_id == 3 || this.role_id == 4 || this.role_id == 5) {
         // this.sidebarItems.push(defaultMenu);
          // this.sidebarItems.push(defaultLeave)
        }
        // var defaultMenu = {
        //   id: 101,
        //   path: "",
        //   title: "Reports",
        //   moduleName: "report",
        //   iconType: "material-icons-two-tone",
        //   icon: "content_paste",
        //   class: "menu-toggle",
        //   groupTitle: false,
        //   badge: "",
        //   badgeClass: "",
        //   role: [this.userType],
        //   submenu: [
        //     {
        //       path: "/admin/employees/attendance-monthly",
        //       title: "Attendance Details",
        //       moduleName: "attendance",
        //       iconType: "",
        //       icon: "",
        //       class: "ml-menu",
        //       groupTitle: true,
        //       badge: "",
        //       badgeClass: "",
        //       role: [""],
        //       submenu: [],
        //     },
        //     {
        //       path: "/admin/employees/attendance-summary",
        //       title: "Attendance Summary",
        //       moduleName: "summary",
        //       iconType: "",
        //       icon: "",
        //       class: "ml-menu",
        //       groupTitle: true,
        //       badge: "",
        //       badgeClass: "",
        //       role: [""],
        //       submenu: [],
        //     },
        //     {
        //       path: "/admin/employees/employee-attendance-report",
        //       title: "Employee Attendance Report",
        //       moduleName: "employee-attendance-report",
        //       iconType: "",
        //       icon: "",
        //       class: "ml-menu",
        //       groupTitle: true,
        //       badge: "",
        //       badgeClass: "",
        //       role: [""],
        //       submenu: [],
        //     },
        //     {
        //       path: "/admin/app-reports/employee-attendance-report",
        //       title: "Mobile App report",
        //       moduleName: "employee-attendance-report",
        //       iconType: "",
        //       icon: "",
        //       class: "ml-menu",
        //       groupTitle: true,
        //       badge: "",
        //       badgeClass: "",
        //       role: [""],
        //       submenu: [],
        //     },
        //     {
        //       path: "/admin/app-reports/tracking-report",
        //       title: "Mobile App tracking report",
        //       moduleName: "employee-attendance-report",
        //       iconType: "",
        //       icon: "",
        //       class: "ml-menu",
        //       groupTitle: true,
        //       badge: "",
        //       badgeClass: "",
        //       role: [""],
        //       submenu: [],
        //     },
        //   ],
        // };

        if (this.role_id == 1 || this.role_id == 2 || this.role_id == 3 || this.role_id == 4 || this.role_id == 5) {
          //this.sidebarItems.push(defaultMenu);
        }

        // var defaultMenu = {
        //   id: 101,
        //   path: "",
        //   title: "Master Management",
        //   moduleName: "master",
        //   iconType: "material-icons-two-tone",
        //   icon: "settings",
        //   class: "menu-toggle",
        //   groupTitle: false,
        //   badge: "",
        //   badgeClass: "",
        //   role: [this.userType],
        //   submenu: [
        //     {
        //       path: "/admin/masters/all-masters",
        //       title: "Manage Master",
        //       moduleName: "masters",
        //       iconType: "",
        //       icon: "",
        //       class: "ml-menu",
        //       groupTitle: true,
        //       badge: "",
        //       badgeClass: "",
        //       role: [""],
        //       submenu: [],
        //     },
        //   ],
        // };

        if (this.role_id == 1) {
        //  this.sidebarItems.push(defaultMenu);
        }

        // var defaultMenu = {
        //   id: 101,
        //   path: "",
        //   title: "Calendar",
        //   moduleName: "academic-event-calendar",
        //   iconType: "material-icons-two-tone",
        //   icon: "today",
        //   class: "menu-toggle",
        //   groupTitle: false,
        //   badge: "",
        //   badgeClass: "",
        //   role: [this.userType],
        //   submenu: [
        //     {
        //       path: "/admin/holidays/manage_academic_events",
        //       title: "Holiday Calendar",
        //       moduleName: "academic-event-calendar",
        //       iconType: "",
        //       icon: "",
        //       class: "ml-menu",
        //       groupTitle: true,
        //       badge: "",
        //       badgeClass: "",
        //       role: [""],
        //       submenu: [],
        //     },
        //   ],
        // };
        if (this.role_id == 1) {
         // this.sidebarItems.push(defaultMenu);
        }
      }

      for (
        let mainMenuIndex = 0;
        mainMenuIndex < parsedMenuObject.length;
        mainMenuIndex++
      ) {
        if (parsedMenuObject[mainMenuIndex].sub_menu_id == 0) {
          let menu = {
            id: parsedMenuObject[mainMenuIndex].main_menu_id,
            path:
              parsedMenuObject[mainMenuIndex].menu_url == null
                ? ""
                : parsedMenuObject[mainMenuIndex].menu_url,
            title: parsedMenuObject[mainMenuIndex].menu_name,
            moduleName: parsedMenuObject[mainMenuIndex].menu_module,
            iconType: "material-icons-two-tone",
            icon: parsedMenuObject[mainMenuIndex].menu_icon,
            class: "",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            role: [this.userType],
            submenu: [],
          };
          this.sidebarItems.push(menu);
        }
      }

      for (
        let mainMenuIndex = 0;
        mainMenuIndex < this.sidebarItems.length;
        mainMenuIndex++
      ) {
   
        for (
          let subMenuIndex = 0;
          subMenuIndex < parsedMenuObject.length;
          subMenuIndex++
        ) {
          if (
            this.sidebarItems[mainMenuIndex].id ==
              parsedMenuObject[subMenuIndex].main_menu_id &&
            parsedMenuObject[subMenuIndex].sub_menu_id != 0
          ) {
            let submenu = {
              id: parsedMenuObject[subMenuIndex].sub_menu_id,
              path: parsedMenuObject[subMenuIndex].menu_url,
              title: parsedMenuObject[subMenuIndex].menu_name,
              moduleName: parsedMenuObject[subMenuIndex].menu_module,
              iconType: "",
              icon: "",
              class: "ml-menu",
              groupTitle: true,
              badge: "",
              badgeClass: "",
              role: [""],
              submenu: [],
            };
            this.sidebarItems[mainMenuIndex].submenu.push(submenu);
            this.sidebarItems[mainMenuIndex].class = "menu-toggle";
            this.sidebarItems[mainMenuIndex].submenu.sort(
              this.sortByProperty("id")
            );
            this.sidebarItems[mainMenuIndex].submenu = [
              ...this.sidebarItems[mainMenuIndex].submenu,
            ];
          }
        }
      }
    }

    this.initLeftSidebar();
    this.bodyTag = this.document.body;
  }

  sortByProperty(property) {
    return function (a, b) {
      if (a[property] > b[property]) return 1;
      else if (a[property] < b[property]) return -1;
      return 0;
    };
  }

  ngOnDestroy() {
    this.routerObj.unsubscribe();
  }
  initLeftSidebar() {
    const _this = this;
    // Set menu height
    _this.setMenuHeight();
    _this.checkStatuForResize(true);
  }
  setMenuHeight() {
    this.innerHeight = window.innerHeight;
    const height = this.innerHeight - this.headerHeight;
    this.listMaxHeight = height + "";
    this.listMaxWidth = "500px";
  }
  isOpen() {
    return this.bodyTag.classList.contains("overlay-open");
  }
  checkStatuForResize(firstTime) {
    if (window.innerWidth < 1170) {
      this.renderer.addClass(this.document.body, "ls-closed");
    } else {
      this.renderer.removeClass(this.document.body, "ls-closed");
    }
  }
  mouseHover(e) {
    const body = this.elementRef.nativeElement.closest("body");
    if (body.classList.contains("submenu-closed")) {
      this.renderer.addClass(this.document.body, "side-closed-hover");
      this.renderer.removeClass(this.document.body, "submenu-closed");
    }
  }
  mouseOut(e) {
    const body = this.elementRef.nativeElement.closest("body");
    if (body.classList.contains("side-closed-hover")) {
      this.renderer.removeClass(this.document.body, "side-closed-hover");
      this.renderer.addClass(this.document.body, "submenu-closed");
    }
  }
}
